import { render } from "./ApeConstructorTraits.vue?vue&type=template&id=176f4eb4"
import script from "./ApeConstructorTraits.vue?vue&type=script&lang=js"
export * from "./ApeConstructorTraits.vue?vue&type=script&lang=js"

import "./ApeConstructorTraits.vue?vue&type=style&index=0&id=176f4eb4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__